import { useState, useEffect, useCallback, useContext } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import { AuthContext } from "../../../../common/middlewares/Auth";

const useGetSurveyStatus = ({ autoLoad = true, strEmail } = {}) => {
  const [dataStatus, setDataStatus] = useState(null); // Puede ser número o objeto
  const authContext = useContext(AuthContext);
  const { token } = authContext;

  const getData = useCallback(
    async ({ strEmail }) => {
      if (!strEmail) {
        toast.error("Correo no proporcionado");
        return null;
      }

      try {
        const res = await axios({
          method: "GET",
          baseURL: `${process.env.REACT_APP_PROTOCOL_BACKEND}://${process.env.REACT_APP_HOST_BACKEND}${process.env.REACT_APP_PORT_BACKEND}`,
          url: `${process.env.REACT_APP_API_GETSURVEYSTATUS}`,
          params: { strEmail },
          headers: { token },
        });

        const result = res.data?.totalActivas ?? res.data?.data ?? null;
        setDataStatus(result);
        return result;
      } catch (error) {
        if (!axios.isCancel(error)) {
          const msg = error.response?.data?.msg || error.message;
          toast.error(msg);
          setDataStatus(null);
          throw error;
        }
      }
    },
    [token]
  );

  const refreshGetDataStatus = useCallback(
    ({ strEmail }) => {
      setDataStatus(null);
      return getData({ strEmail });
    },
    [getData]
  );

  const clearDataStatus = useCallback(() => {
    setDataStatus(null);
  }, []);

  useEffect(() => {
    if (autoLoad && strEmail) {
      refreshGetDataStatus({ strEmail });
    }
  }, [autoLoad, strEmail, refreshGetDataStatus]);  

  return { dataStatus, refreshGetDataStatus, clearDataStatus };
};

export { useGetSurveyStatus };